import { controls, grouped } from "../controls";
const pacs_manual_recoveries = {
  label: "Pacs Manual Recoveries",
  pageLabel: "Pacs Manual Recoveries", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  bulk: { columns: ["taluka_code", "disbursement_count", "outstanding_count"] },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Region" }),
    ...controls.oc({ tab: "filter", c: "Region", placeHolder: "Region Code", name: "PACSManualRecovery-region-region_code", fastpath: "regions" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "PACSManualRecovery-region-region_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Region", star: true }),
    ...controls.oc({ tab: "general", c: "Region", placeHolder: "Region Code", name: "region_code", isRequired: true, fastpath: "regions" }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "region_display" }),
    ...controls.displayText({ tab: "general", label: "Code", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "taluka_code", isRequired: false, maxlength: 10 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Disbursement Count", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "disbursement_count", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Outstanding Count", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "outstanding_count", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "NPA Count", star: false }),
    ...controls.numberOnly({ tab: "general", placeHolder: "", name: "npa_count", isRequired: false, maxlength: 200 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "NPA Amount" }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "npa_amount", maxlength: 18 }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Pacs Manual Recoveries",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Region", accessor: "PACSManualRecovery-region-region_display", },
      { Header: "Taluka", accessor: "taluka_code", },
      { Header: "Disbursement Count", accessor: "disbursement_count", },
      { Header: "Outstanding Count", accessor: "outstanding_count", },
      { Header: "NPA Count", accessor: "npa_count", },
      { Header: "NPA Amount", accessor: "npa_amount", },
    ]
  }
};
export default pacs_manual_recoveries;